import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { CGradientButton } from "../../componets/button/gradient";
import CTypography from "../../componets/typography";
import { PRIVACY_LAST_UPDATED, PRIVACY_SECTIONS } from "./data";
import {
	ItemBodyGrey,
	ItemContainer,
	ItemTitle,
	ItemTitlePrefix,
	MainTitle,
	TermsStyled,
	TitleWrapper,
	StyledTable,
	TableContainer,
} from "./privacy-styled";

export const PrivacyPolicy = () => {
	const { pathname } = useLocation();

	useLayoutEffect(() => {
		window.scrollTo({ top: 0, behavior: "smooth" });
	}, [pathname]);

	return (
		<TermsStyled>
			<TitleWrapper>
				<CGradientButton className="privacy-badge">
					<CTypography
						color="var(--Blue)"
						weight="bold"
						className="privacy-button-text"
					>
						Legal terms
					</CTypography>
				</CGradientButton>
				<MainTitle color="var(--Black)" weight="bold" className="black-title">
					CorePass: Privacy Policy
				</MainTitle>
				<ItemBodyGrey>Last updated: {PRIVACY_LAST_UPDATED}</ItemBodyGrey>
			</TitleWrapper>

			{PRIVACY_SECTIONS.map((section) => (
				<ItemContainer key={section.number}>
					<ItemTitle>
						<ItemTitlePrefix>{section.number}.</ItemTitlePrefix>
						{section.title}
					</ItemTitle>
					{section.paragraphs.map((paragraph, index) => {
						if (section.number === "8" && index === 1) {
							const [caption, ...cells] = paragraph.split("\n").map((line) => line.trim()).filter(Boolean);
							return (
								<TableContainer key={`${section.number}-${index}`}>
									<StyledTable>
										<caption>{caption}</caption>
										<thead><tr><th>{cells[0]}</th><th>{cells[1]}</th></tr></thead>
										<tbody>
											{cells.slice(2).filter((_, cellIndex) => cellIndex % 2 === 0).map((name, rowIndex) => (
												<tr key={name}><td>{name}</td><td>{cells[3 + rowIndex * 2]}</td></tr>
											))}
										</tbody>
									</StyledTable>
								</TableContainer>
							);
						}
						return <ItemBodyGrey key={`${section.number}-${index}`}>{paragraph}</ItemBodyGrey>;
					})}
				</ItemContainer>
			))}
		</TermsStyled>
	);
};
